{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Setări cont",
    "SUBMIT": "Actualizați setările",
    "BACK": "Înapoi",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Nu s-au putut actualiza setările, încercați din nou!",
      "SUCCESS": "Setările contului actualizate cu succes"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Şterge",
        "DISMISS": "Renunță",
        "PLACE_HOLDER": "Vă rugăm să tastați {accountName} pentru a confirma"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Vă rugăm să remediați erorile din formular",
      "GENERAL_SECTION": {
        "TITLE": "Setări generale",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID cont",
        "NOTE": "Acest ID este necesar dacă construiți o integrare bazată pe API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferințe",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Nume cont",
        "PLACEHOLDER": "Numele contului tău",
        "ERROR": "Te rugăm să introduci un nume de cont valid"
      },
      "LANGUAGE": {
        "LABEL": "Limba site-ului",
        "PLACEHOLDER": "Numele contului tău",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domeniu e-mail de intrare",
        "PLACEHOLDER": "Domeniul în care veți primi e-mailurile",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail de suport",
        "PLACEHOLDER": "E-mailul de asistență al companiei dumneavoastră",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Actualizare",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Continuitatea conversației cu e-mailurile este activată pentru contul dvs.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Puteți primi e-mailuri în domeniul dvs. personalizat acum."
      }
    },
    "UPDATE_CHATWOOT": "Este disponibilă o actualizare {latestChatwootVersion} pentru Chatwoot. Vă rugăm să actualizați instanța.",
    "LEARN_MORE": "Află mai mult",
    "PAYMENT_PENDING": "Plata dvs. este în așteptare. Vă rugăm să actualizați informațiile de plată pentru a continua să utilizați Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Contul dvs. a depășit limitele de utilizare, vă rugăm să vă actualizați planul pentru a continua să utilizați Chatwoot",
    "OPEN_BILLING": "Deschide facturarea"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Apăsați enter pentru a selecta",
      "ENTER_TO_REMOVE": "Introduceți numele complet al persoanei de contact",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Alege una",
      "SELECT": "Selectați"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notificări",
    "MARK_ALL_DONE": "Marcați toate gata",
    "DELETE_TITLE": "șterse",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notificări necitite",
      "ALL_NOTIFICATIONS": "Vizualizarea tuturor notificărilor",
      "LOADING_UNREAD_MESSAGE": "Încărcarea notificărilor necitite...",
      "EMPTY_MESSAGE": "Nu aveți notificări necitite"
    },
    "LIST": {
      "LOADING_MESSAGE": "Se încarcă contactele...",
      "404": "Notificări prin e-mail",
      "TABLE_HEADER": [
        "Nume",
        "Număr de telefon",
        "Conversații",
        "Ultimul contactat"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Conversație nouă",
      "conversation_assignment": "Conversație atribuită",
      "assigned_conversation_new_message": "Trimite mesaj nou",
      "participating_conversation_new_message": "Trimite mesaj nou",
      "conversation_mention": "Menţiune",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Deconectat",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Reîmprospătare"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Căutarea sau saltul la",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Rapoarte",
      "CONVERSATION": "Conversație",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Modificarea cesionarului",
      "CHANGE_PRIORITY": "Modificarea priorității",
      "CHANGE_TEAM": "Schimbarea echipei",
      "SNOOZE_CONVERSATION": "Snooze conversație",
      "ADD_LABEL": "Adăugarea etichetei la conversație",
      "REMOVE_LABEL": "Eliminarea etichetei din conversație",
      "SETTINGS": "Setări",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Accesați Tabloul de bord conversație",
      "GO_TO_CONTACTS_DASHBOARD": "Accesați Tabloul de bord persoane de contact",
      "GO_TO_REPORTS_OVERVIEW": "Accesați Prezentare generală a rapoartelor",
      "GO_TO_CONVERSATION_REPORTS": "Accesați Rapoartele conversațiilor",
      "GO_TO_AGENT_REPORTS": "Accesați povestea Instagram",
      "GO_TO_LABEL_REPORTS": "Accesați Etichetarea rapoartelor",
      "GO_TO_INBOX_REPORTS": "Accesați Rapoarte Inbox",
      "GO_TO_TEAM_REPORTS": "Accesați Rapoarte de echipă",
      "GO_TO_SETTINGS_AGENTS": "Accesați Setări agent",
      "GO_TO_SETTINGS_TEAMS": "Accesați Setările echipei",
      "GO_TO_SETTINGS_INBOXES": "Accesați Setări Inbox",
      "GO_TO_SETTINGS_LABELS": "Accesați Setări etichetă",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Accesați Setări răspuns conservat",
      "GO_TO_SETTINGS_APPLICATIONS": "Accesați Setări aplicație",
      "GO_TO_SETTINGS_ACCOUNT": "Accesați Setări cont",
      "GO_TO_SETTINGS_PROFILE": "Accesați Setări profil",
      "GO_TO_NOTIFICATIONS": "Accesați Notificări",
      "ADD_LABELS_TO_CONVERSATION": "Adăugarea etichetei la conversație",
      "ASSIGN_AN_AGENT": "Atribuirea unui agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Atribuirea priorității",
      "ASSIGN_A_TEAM": "Atribuirea unei echipe",
      "MUTE_CONVERSATION": "Silențios conversația",
      "UNMUTE_CONVERSATION": "Sunet conversația",
      "REMOVE_LABEL_FROM_CONVERSATION": "Eliminarea etichetei din conversație",
      "REOPEN_CONVERSATION": "Redeschiderea conversației",
      "RESOLVE_CONVERSATION": "Rezolvarea conversației",
      "SEND_TRANSCRIPT": "Trimiterea unei transcrieri a e-mailului",
      "SNOOZE_CONVERSATION": "Snooze conversație",
      "UNTIL_NEXT_REPLY": "Până la următorul răspuns",
      "UNTIL_NEXT_WEEK": "Până săptămâna viitoare",
      "UNTIL_TOMORROW": "Până mâine",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "Sistem",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Se încarcă aplicația Dashboard..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click aici"
  }
}
